import { Stack } from '@mui/material';
import { useLocalization } from '@ui-framework/index';
import { PageSection } from '@product-framework/index';
import { useServiceModule } from '@product-framework/components/ServiceModuleProvider';
import DispatchNotifications from './DispatchNotifications';
import InsightContact from './InsightContact';

function Setup({ onChange = () => undefined }) {
  const { formatMessage } = useLocalization();
  const { moduleSettings = {} } = useServiceModule();

  const isDispatchPurchased = moduleSettings.dispatchPurchased;
  const isInsightPurchased = moduleSettings.insightPurchased;

  if (!isDispatchPurchased && !isInsightPurchased) {
    return null;
  }

  return (
    <PageSection
      label={formatMessage({
        id: 'SERVICE_PROVIDER_NOTIFICATIONS_EDIT_HEADING',
        defaultMessage: 'Setup',
      })}>
      <Stack spacing={4} sx={{ width: '100%' }}>
        {isDispatchPurchased && <DispatchNotifications onChange={onChange} />}
        {isInsightPurchased && <InsightContact onChange={onChange} />}
      </Stack>
    </PageSection>
  );
}

export default Setup;
